// Import all images
import oilwomanwithumbrella from "../images/oilwomanwithumbrella.jpg";
import oilwaves from "../images/oilwaves.jpg";
import oilspaceshuttle from "../images/oilspaceshuttle.jpg";
import watercolorvenice from "../images/watercolorvenice.jpg";
import dawncamp from "../images/dawncamp.JPG";
import kyotofestival from "../images/kyotofestival.jpg";
import osaka from "../images/osaka.jpeg";
import hokkaido from "../images/hokkaido.jpeg";
import multimediaflyerfinal from "../images/multimediaflyerfinal.png";
import bobrossMMAC from "../images/bobrossMMAC.png";
import totebagredone from "../images/totebagredone.png";
import osakaspace from "../images/osakaspace.jpeg";
import spacecraft from "../images/spacecraft.jpg";
import whatsthis from "../images/E060A810-9ED8-4DC8-B34A-2AFF93B1A0BE.jpg";
import stickseasonbluejay from "../images/stickseasonbluejay.jpg";
import frenchiedog from "../images/frenchiedog.jpg";
import manwithbath from "../images/manwithbath.jpg";

// Map image keys to imported images
const imageMap = {
  "oilwomanwithumbrella": oilwomanwithumbrella,
  "oilwaves": oilwaves,
  "oilspaceshuttle": oilspaceshuttle,
  "watercolorvenice": watercolorvenice,
  "dawncamp": dawncamp,
  "kyotofestival": kyotofestival,
  "osaka": osaka,
  "hokkaido": hokkaido,
  "multimediaflyerfinal": multimediaflyerfinal,
  "bobrossMMAC": bobrossMMAC,
  "totebagredone": totebagredone,
  "osakaspace": osakaspace,
  "spacecraft": spacecraft,
  "tuolumne": whatsthis,
  "stickseasonbluejay": stickseasonbluejay,
  "frenchiedog": frenchiedog,
  "manwithbath": manwithbath
};

export default imageMap;